"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = exports.Direction = void 0;
var Direction;
(function (Direction) {
    Direction[Direction["Stop"] = 0] = "Stop";
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Reverse"] = 2] = "Reverse";
    Direction[Direction["Left"] = 3] = "Left";
    Direction[Direction["Right"] = 4] = "Right";
})(Direction = exports.Direction || (exports.Direction = {}));
exports.actionCreators = {
    requestMovement: function (direction, leftSpeed, rightSpeed) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.movement && appState.clientList && appState.clientList.connectedClient) {
            var requestBody = JSON.stringify({
                leftSpeed: leftSpeed,
                rightSpeed: rightSpeed,
                direction: direction,
                clientTimeEpoch: Date.now()
            });
            fetch("/move/" + appState.clientList.connectedClient.sessionGuid + "/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: requestBody
            })
                .then(function (response) { return response.json(); })
                .then(function (data) { return dispatch({ type: 'FINISHED_REQUESTING_MOVEMENT', finishedDirection: direction }); });
            dispatch({ type: 'REQUEST_MOVEMENT', requestedDirection: direction });
        }
    }; },
    gamePadConnected: function (index) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.movement) {
            dispatch({ type: 'GAME_PAD_DETECTED', index: index });
        }
    }; },
    gamePadDisconnected: function () { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.movement) {
            dispatch({ type: 'GAME_PAD_REMOVED' });
        }
    }; }
};
var unloadedState = { isSending: false, lastRequestedDirection: Direction.Stop, gamePadIndex: undefined };
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_MOVEMENT':
            return {
                isSending: true,
                lastRequestedDirection: action.requestedDirection,
                gamePadIndex: state.gamePadIndex
            };
        case 'FINISHED_REQUESTING_MOVEMENT':
            return {
                isSending: false,
                lastRequestedDirection: state.lastRequestedDirection,
                gamePadIndex: state.gamePadIndex
            };
        case 'GAME_PAD_DETECTED':
            return {
                isSending: state.isSending,
                lastRequestedDirection: state.lastRequestedDirection,
                gamePadIndex: action.index
            };
        case 'GAME_PAD_REMOVED':
            return {
                isSending: state.isSending,
                lastRequestedDirection: state.lastRequestedDirection,
                gamePadIndex: undefined
            };
        default:
            return state;
    }
};
//# sourceMappingURL=Movement.js.map